/* eslint no-param-reassign: "error" */

export default {
  SET_SYSTEM_SETTINGS(state, data){
    state.contractSettings = data;
  },

  SET_COUNTERPARTY_GROUP(state, data){
    state.counterpartyGroup = data;
  },

};
